"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("bootstrap");
const heroBanner_1 = __importDefault(require("./components/heroBanner"));
const testimonialSlider_1 = __importDefault(require("./components/testimonialSlider"));
const woocommerceProductData_1 = __importDefault(require("./components/woocommerceProductData"));
const banner_1 = __importDefault(require("./components/banner"));
const projectSlider_1 = __importDefault(require("./components/projectSlider"));
const timelineSlider_1 = __importDefault(require("./components/timelineSlider"));
const pageSlider_1 = __importDefault(require("./components/pageSlider"));
const swiper_1 = __importStar(require("swiper"));
const framework_1 = __importDefault(require("./packages/component-framework/framework"));
swiper_1.default.use([swiper_1.Navigation, swiper_1.Pagination, swiper_1.EffectFade]);
window.Burger = {
    SecretSauce: new framework_1.default([
        heroBanner_1.default,
        testimonialSlider_1.default,
        timelineSlider_1.default,
        woocommerceProductData_1.default,
        banner_1.default,
        projectSlider_1.default,
        pageSlider_1.default,
    ])
};
